import ChipArrayCode from "!!raw-loader!./chips/ChipArray.tsx";
import ChipSelectCode from "!!raw-loader!./chips/ChipSelect.tsx";
import DisabledCode from "!!raw-loader!./chips/Disabled.tsx";
import LocalizedCode from "!!raw-loader!./chips/Localized.tsx";
import OverflowCode from "!!raw-loader!./chips/Overflow.tsx";
import VariantCode from "!!raw-loader!./chips/Variant.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import ChipArray from "./chips/ChipArray";
import ChipSelect from "./chips/ChipSelect";
import Disabled from "./chips/Disabled";
import Localized from "./chips/Localized";
import Overflow from "./chips/Overflow";
import Variant from "./chips/Variant";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Variant", VariantCode, Variant),
		paneComponent("Overflow", OverflowCode, Overflow),
		paneComponent("Disabled", DisabledCode, Disabled),
		paneComponent("Localized", LocalizedCode, Localized),
		paneComponent("ChipArray", ChipArrayCode, ChipArray),
		paneComponent("ChipSelect", ChipSelectCode, ChipSelect),
	];

	return (
		<Pane
			components={components}
			imports={"import {Chip} from \"designSystem/index\";"}
			muiApi="chip"
			muiComponent="chips"
			{...props}
		/>
	);
};